import React from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { Button } from 'antd';
import useCheckIsMobile from '@/lib/hooks/useCheckIsMobile';

const DownloadStoriesBottomContent = ({
  bottomInfo,
  onSearchClick,
  loading,
  inputValueControl,
}: {
  bottomInfo?: {
    title?: string;
    desc?: string;
  };
  onSearchClick: (text: string) => void;
  loading: boolean;
  inputValueControl: [string, (searchStr: string) => void];
}) => {
  const { t } = useTranslation('common');
  const [searchStr, setSearchStr] = inputValueControl;

  const { isMobile } = useCheckIsMobile();

  const getInputItem = () => {
    return (
      <div className={styles.inputContainer}>
        <Image src={'/images/home/instagram-icon.webp'} alt="instagram" width={24} height={24} />
        <input
          disabled={loading}
          value={searchStr}
          onChange={(e) => setSearchStr(e.target.value)}
          onKeyDown={(e) => {
            if (e?.key === 'Enter') {
              const value = (e.target as HTMLInputElement).value;
              setSearchStr(value);
              onSearchClick && onSearchClick(value);
            }
          }}
          placeholder={t('Enter an Instagram username or profile link')}
        />
        <Button
          loading={loading}
          className={styles.searchBtn}
          disabled={loading}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            onSearchClick && onSearchClick(searchStr);
          }}
        >
          {t('Search Now')}
        </Button>
      </div>
    );
  };

  const getContent = () => {
    return (
      <div className={styles.content}>
        <div className={styles.mainContent}>
          <h2 className={styles.title}>{bottomInfo?.title}</h2>
          <p className={styles.desc}>{bottomInfo?.desc}</p>
          {getInputItem()}
        </div>
      </div>
    );
  };

  if (!bottomInfo) return null;

  return isMobile ? getInputItem() : getContent();
};

export default DownloadStoriesBottomContent;
